<!--<div style="height: 5%; width: 97%; margin: auto; background: white; display:flex; flex-direction:row; justify-content:flex-end;align-items:center">
  <div>
    <button class="refresh-btn" (click)="refreshComponent()">
      <span class="bi bi-arrow-clockwise"></span>
      Refresh
    </button>
  </div>
</div>-->
<div class="main-body position-relative container-div">
  <div *ngFor="let dep of clientSessions; let i = index">
    <mat-expansion-panel
      *ngFor="let nodeGroup of dep.nodeGroups; let i = index"
      expanded
      style="margin-bottom: 40px; box-shadow: none !important"
    >
      <mat-expansion-panel-header
        class="border-bottom"
        style="border-radius: 0px"
      >
        <mat-panel-title>
          <h3 style="margin: 0">
            {{ dep.referenceDeploymentName }} : {{ nodeGroup.name }}
          </h3>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div style="display: flex; flex-wrap: wrap">
        <div
          *ngIf="nodeGroup.hasWindow"
          style="
            display: flex;
            flex-direction: column;
            max-width: 100px;
            align-items: center;
            margin: 20px;
            padding: 10px;
          "
        >
          <span
            class="deployment-image"
            style="position: relative; display: inline-block"
          >
            <img
              src="../../../../assets/images/client/windows_icon.png"
              (dblclick)="
                getSessionFromDeployment(
                  dep.deploymentName,
                  nodeGroup.name,
                  'windows'
                )
              "
              width="50px"
              height="50px"
              style="background-color: white; padding: 5px"
            />
            <ngx-spinner
              bdColor="rgba(0,0,0,0)"
              size="small"
              color="var(--s-primary-color)"
              type="ball-spin"
              [fullScreen]="false"
              [name]="nodeGroup.name + '-windows'"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                pointer-events: none;
              "
            >
            </ngx-spinner>
          </span>
          <div style="padding: 5px; max-width: inherit">
            <p style="width: 100%; margin: 0px; overflow-wrap: break-word">
              Desktop
            </p>
          </div>
        </div>
        <div
          *ngIf="nodeGroup.hasLinux"
          style="
            display: flex;
            flex-direction: column;
            max-width: 100px;
            align-items: center;
            margin: 20px;
            padding: 10px;
          "
        >
          <span
            class="deployment-image"
            style="position: relative; display: inline-block"
          >
            <img
              src="../../../../assets/images/client/linux_icon.png"
              (dblclick)="
                getSessionFromDeployment(
                  dep.deploymentName,
                  nodeGroup.name,
                  'linux'
                )
              "
              width="50px"
              height="50px"
              style="background-color: white; padding: 5px"
            />
            <ngx-spinner
              bdColor="rgba(0,0,0,0)"
              size="small"
              color="var(--s-primary-color)"
              type="ball-spin"
              [fullScreen]="false"
              [name]="nodeGroup.name + '-linux'"
              style="
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                pointer-events: none;
              "
            >
            </ngx-spinner>
          </span>
          <div style="padding: 5px; max-width: inherit">
            <p style="width: 100%; margin: 0px; overflow-wrap: break-word">
              Desktop
            </p>
          </div>
        </div>
      </div>
      <div
        *ngIf="false"
        class="d-flex justify-content-center align-items-center"
        style="height: 200px"
      >
        <p style="margin: 0; font-size: 12px">No Synchpc Service Available</p>
      </div>
    </mat-expansion-panel>
  </div>
</div>
<ng-template #clientSessionHTML>
  <div
    class="tooltipNodeName tooltip-content"
    style="text-align: left"
    [innerHTML]="clientSessionTooltipHtml | safeHtml"
  ></div>
</ng-template>

<!--<div *ngFor="let dep of clientSessions let i = index" class="deployment-container">
  <div class="deployment-name border-bottom">
    <p style="font-size: x-large; font-family: 'Ubuntu', sans-serif; color: var(--s-primary-color); padding: 12px; margin: 0 ">
      {{ dep.referenceDeploymentName }}
    </p>
  </div>
  <div class="deployment">
    <div style="display:flex;height:100%; flex-direction:row; align-items:center; padding:20px">-->

<!--<svg (dblclick)="getSessionFromDeployment(dep.deploymentName)" width="70px" height="70px" viewBox="0 0 1024 1024" class="icon deployment-image" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" stroke-width="0.01024"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M447.934 684h136v179h-136z" fill="#0072ba"></path><path d="M587.934 867h-144V680h144v187z m-136-8h128V688h-128v171z" fill="#515151"></path><path d="M872.934 698.076h-724c-11.046 0-20-8.954-20-20v-472c0-11.046 8.954-20 20-20h724c11.046 0 20 8.954 20 20v472c0 11.046-8.955 20-20 20z" fill="#0072ba"></path><path d="M872.934 702.076h-724c-13.234 0-24-10.766-24-24v-472c0-13.233 10.766-24 24-24h724c13.234 0 24 10.767 24 24v472c0 13.234-10.767 24-24 24z m-724-512c-8.822 0-16 7.178-16 16v472c0 8.822 7.178 16 16 16h724c8.822 0 16-7.178 16-16v-472c0-8.822-7.178-16-16-16h-724z" fill="#515151"></path><path d="M889 621H133V206.538c0-9.092 7.37-16.462 16.462-16.462h723.076c9.092 0 16.462 7.37 16.462 16.462V621z" fill="#71d1f4"></path><path d="M324 863h383" fill="#0072ba"></path><path d="M707 867H324a4 4 0 0 1 0-8h383a4 4 0 0 1 0 8z" fill="#515151"></path><path d="M177.248 350.183l86.995-86.996" fill="#0072ba"></path><path d="M177.248 354.183a4 4 0 0 1-2.829-6.828l86.996-86.996a4 4 0 0 1 5.657 5.657l-86.996 86.996a3.991 3.991 0 0 1-2.828 1.171z" fill="#D7F9FF"></path><path d="M177.248 420.679L329.37 268.557" fill="#0072ba"></path><path d="M177.248 424.679a4 4 0 0 1-2.829-6.828l152.123-152.123a4 4 0 0 1 5.657 5.657L180.076 423.508a3.987 3.987 0 0 1-2.828 1.171z" fill="#D7F9FF"></path></g></svg>
      <svg (dblclick)="getSessionFromDeployment(dep.deploymentName)" width="70px" height="70px" viewBox="0 0 1024 1024" class="icon deployment-image" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000" stroke="#000000" stroke-width="0.01024"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M447.934 684h136v179h-136z" fill="#0072ba"></path><path d="M587.934 867h-144V680h144v187z m-136-8h128V688h-128v171z" fill="#515151"></path><path d="M872.934 698.076h-724c-11.046 0-20-8.954-20-20v-472c0-11.046 8.954-20 20-20h724c11.046 0 20 8.954 20 20v472c0 11.046-8.955 20-20 20z" fill="#0072ba"></path><path d="M872.934 702.076h-724c-13.234 0-24-10.766-24-24v-472c0-13.233 10.766-24 24-24h724c13.234 0 24 10.767 24 24v472c0 13.234-10.767 24-24 24z m-724-512c-8.822 0-16 7.178-16 16v472c0 8.822 7.178 16 16 16h724c8.822 0 16-7.178 16-16v-472c0-8.822-7.178-16-16-16h-724z" fill="#515151"></path><path d="M889 621H133V206.538c0-9.092 7.37-16.462 16.462-16.462h723.076c9.092 0 16.462 7.37 16.462 16.462V621z" fill="#71d1f4"></path><path d="M324 863h383" fill="#0072ba"></path><path d="M707 867H324a4 4 0 0 1 0-8h383a4 4 0 0 1 0 8z" fill="#515151"></path><path d="M177.248 350.183l86.995-86.996" fill="#0072ba"></path><path d="M177.248 354.183a4 4 0 0 1-2.829-6.828l86.996-86.996a4 4 0 0 1 5.657 5.657l-86.996 86.996a3.991 3.991 0 0 1-2.828 1.171z" fill="#D7F9FF"></path><path d="M177.248 420.679L329.37 268.557" fill="#0072ba"></path><path d="M177.248 424.679a4 4 0 0 1-2.829-6.828l152.123-152.123a4 4 0 0 1 5.657 5.657L180.076 423.508a3.987 3.987 0 0 1-2.828 1.171z" fill="#D7F9FF"></path></g></svg>-->
<!--<p style="font-size:1.3em; margin-left: 5%">{{dep.referenceDeploymentName
        }}
      </p>-->
<!--<div class="icon deployment-image">
        <span>
          <i style="font-size:xx-large" class="bi bi-microsoft" (dblclick)="getSessionFromDeployment(dep.deploymentName, 'windows')"></i>
        </span>
      </div>
      <div class="icon deployment-image" style="margin-left: 30px">
        <span>
          <i style="font-size:xx-large" class="bi bi-ubuntu" (dblclick)="getSessionFromDeployment(dep.deploymentName, 'linux')"></i>
        </span>
      </div>

      <div style="position: relative; height:100%; width:30%">
        <ngx-spinner bdColor="rgba(0,0,0,0)"
                     size="small"
                     color="var(--s-primary-color)"
                     type="ball-spin"
                     [fullScreen]="false"
                     [name]="dep.deploymentName">
        </ngx-spinner>
      </div>
    </div>
  </div>
  <div class="sessions-container" *ngIf="dep.sessions.length > 0">
    <div *ngFor="let session of dep.sessions" class="single-session-container">
      <div class="session-wrapper">
        <div class="session-wrapper_session-name">
          <div style="overflow:hidden;width:90%">
            <p title="{{session.name}}" style="margin:0; color:var(--s-primary-color); display:inline-block">
              {{session.name}}
            </p>
          </div>
          <i class="bi bi-info-circle"
             style="color: var(--s-primary-color)"
             placement="bottom-left"
             container="body"
             [autoclose]="true"
             animation="true"
             (mouseover)="getToolTipForSession(session)"
             triggers="hover" [ngbTooltip]="clientSessionHTML">
          </i>
        </div>
        <div class="session-wrapper_session-state">
          <p style="margin:0">{{session.aliasState}}</p>
        </div>
        <div class="session-wrapper_session-buttons">-->
<!--<button style="width: 50%; background-color: var(--s-body-color); border: none">
            <span class="bi bi-link"
                  style="color: var(--s-primary-color); font-size:larger;"
                  title="Connect to on-going session"
                  [ngStyle]="{'opacity': session.state != 'WTSRequested' ? '1' : '0.2'}"
                  (click)="clientConnectSession(session)">
            </span>
          </button>-->
<!--<button style="width: 50%; background-color: var(--s-body-color); border: none">
            <span class="bi bi-link"
                  style="color: var(--s-primary-color); font-size:larger;"
                  title="Connect to on-going session"
                  [ngStyle]="{'opacity': session.state != 'WTSRequested' ? '1' : '0.2'}"
                  (click)="clientConnectSession2(session)">
            </span>
          </button>
          <button style="width: 50%; background-color: var(--s-body-color); border:none">
            <span class="bi bi-box-arrow-right"
                  style="color: var(--s-primary-color); font-size:larger;"
                  title="Connect to on-going session"
                  (click)="removeSession(session)">
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>


              <ngx-spinner bdColor="rgba(0,0,0,0)"
               size="default" zIndex="1"
               color="var(--s-primary-color)"
               type="ball-spin"
               [fullScreen]="false"
               name="sessions"><p>Please wait ...</p></ngx-spinner>-->
